/*
  Input Text
*/

import React from 'react';

// Antd
import { Form } from "antd";

// phone Input
import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

// Localization
import LOCALIZATION from "services/LocalizationService";

// Styling
import '@Vytelle/admin/src/assets/sass/style.scss';

function PhoneNumber({
  name, label, placeholder,
  defaultValue,
  onChange, disabled, required,
  validateTrigger, validator,
  onBlur, readOnly,
}) {

   // Rules
   let rules = [
    { required: required, message: LOCALIZATION.REQUIRED },
    // Custom validation
    {
        message: LOCALIZATION.INVALID_PHONE,
        validator: (_, value) => {
            if (!value || (!!value && isValidPhoneNumber(value))) {
                return Promise.resolve();
            } else {
                return Promise.reject(LOCALIZATION.INVALID_PHONE);
            }
        }
    }
  ];

  // Additional Custom Validations
  !!validator && rules.push({ validator });

  return (
    <Form.Item
      name={name}
      label={label}
      validateTrigger={validateTrigger || "onBlur"}
      rules={rules}
    >
      <PhoneInput
        placeholder={placeholder || label}
        onChange={onChange || null}
        defaultValue={defaultValue}
        disabled={disabled}
        onBlur = {onBlur}
        readOnly={ readOnly }
      />
    </Form.Item>
  );
}

export default PhoneNumber;